import React, { useEffect, useState } from "react";
import { VIP_BONUS_KIT } from "@/data/vipBonusKitConfig";
import { useI18n } from "@/i18n/I18nProvider";
import { formatQty } from "./vipSimulatorUtils";

function normalizeCandidates(src, fallbacks) {
    return [src, ...(Array.isArray(fallbacks) ? fallbacks : [])].filter(Boolean);
}

function PreviewSlot({ cell }) {
    const { item, lang } = useI18n();
    const label = cell?.label ? item(cell.label) : cell?.label;
    const candidates = normalizeCandidates(cell?.src, cell?.iconCandidates);
    const [index, setIndex] = useState(0);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setIndex(0);
        setFailed(false);
    }, [cell?.src, cell?.iconCandidates]);

    const activeSrc = candidates[index] ?? null;

    const handleError = () => {
        if (index < candidates.length - 1) {
            setIndex((i) => i + 1);
            return;
        }
        setFailed(true);
    };

    return (
        <div className="vip-sim-bonus-kit__slot" title={label}>
            {activeSrc && !failed ? (
                <img
                    src={activeSrc}
                    alt=""
                    className="vip-sim-bonus-kit__img"
                    draggable={false}
                    loading="lazy"
                    decoding="async"
                    onError={handleError}
                />
            ) : (
                <span className="vip-sim-bonus-kit__empty" aria-hidden title={label} />
            )}
            {cell?.qty != null && cell.qty > 1 ? (
                <span className="vip-sim-bonus-kit__qty">x{formatQty(cell.qty, lang)}</span>
            ) : null}
        </div>
    );
}

export default function BonusKitInventoryPreview() {
    const { l } = useI18n();
    return (
        <div className="vip-sim-bonus-kit" role="img" aria-label={l(VIP_BONUS_KIT.title)}>
            <p className="vip-sim-bonus-kit__head">{l(VIP_BONUS_KIT.title)}</p>
            {VIP_BONUS_KIT.sections.map((section) => (
                <section key={section.key} className="vip-sim-bonus-kit__section">
                    <h4 className="vip-sim-bonus-kit__section-title">{l(section.title)}</h4>
                    <div
                        className="vip-sim-bonus-kit__grid"
                        style={{ gridTemplateColumns: `repeat(${section.cols}, minmax(0, 1fr))` }}
                    >
                        {section.cells.map((cell, i) => (
                            <PreviewSlot key={`${section.key}-${i}-${cell?.src ?? "empty"}`} cell={cell} />
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
}
